import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class BenefitAdjustmentCreatedEvent extends EventV2<{ claimId: number | string }> {}
